import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { T } from "../tokens";

function ButterflyMark({ size = 40, color = '#F5F1E8' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M 11.3491 9.1962 L 7.7135 6.5549 c -0.7837 -0.5694 -1.7241 -0.6771 -2.5331 -0.0894 C 5.0376 6.5695 4.8725 6.7133 4.7538 6.8766 c -0.8817 1.2135 0.0759 4.9994 1.2894 5.8811 c 0.7319 0.5318 1.542 0.7082 2.5231 0.553 c -0.4199 0.1218 -0.7802 0.3397 -1.0822 0.6538 c -1.0811 1.1169 -1.4845 2.1352 -0.9919 2.8129 C 6.9705 17.4355 7.6266 18.2343 8.0311 18.5282 c 1.2135 0.8817 3.3542 -1.7803 3.3179 -3.1668 L 11.3491 9.1962 z m 1.1314 0 L 16.116 6.555 C 16.8999 5.9854 17.8402 5.8779 18.6492 6.4656 c 0.1431 0.104 0.3082 0.2478 0.4269 0.4109 c 0.8815 1.2137 -0.076 4.9995 -1.2897 5.8811 c -0.7319 0.532 -1.5418 0.7084 -2.5228 0.5531 c 0.4195 0.1217 0.7802 0.3398 1.0819 0.654 c 1.0812 1.117 1.4845 2.135 0.9921 2.8128 c -0.4783 0.6583 -1.1342 1.4569 -1.5389 1.7508 c -1.2134 0.8817 -3.3544 -1.78 -3.3178 -3.1669 l -0.0003 -6.1651 z" 
      stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

export default function LoginPage() {
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ username: "", email: "", password: "", firstName: "", lastName: "" });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (mode === "login") {
        const res = await fetch("api/users/login", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username: form.username, password: form.password }),
        });
        const data = await res.json();
        if (!res.ok) { alert(data.message || "Login failed"); return; }
        alert("Welcome " + data.firstName);
        localStorage.setItem("user", JSON.stringify(data));
        navigate("/menu");
      } else {
        const res = await fetch("api/users/signup", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username: form.username, password: form.password, email: form.email, firstName: form.firstName, lastName: form.lastName }),
        });
        const data = await res.json();
        if (!res.ok) { alert(data.message || "Signup failed"); return; }
        alert("Signup successful! You can login now.");
        setMode("login");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    }
  };

  const field = (label, name, type = "text", placeholder = "") => (
    <div style={{ marginBottom: 16 }}>
      <label style={{ display: 'block', fontFamily: T.font, fontSize: 14, fontWeight: 600, color: T.ink, marginBottom: 8, letterSpacing: '0.01em' }}>
        {label}
      </label>
      <input
        type={type}
        name={name}
        value={form[name]}
        onChange={handleChange}
        placeholder={placeholder}
        style={{
          width: '100%', height: 54, padding: '0 16px',
          background: T.card, border: `1px solid ${T.line}`, borderRadius: T.r.md,
          fontFamily: T.font, fontSize: 17, color: T.ink, outline: 'none',
          letterSpacing: '-0.01em',
        }}
      />
    </div>
  );

  return (
    <div className="lep-page">
      <div className="lep-page-inner" style={{ padding: '0 24px 48px' }}>
        {/* Logo */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14, marginTop: 80, marginBottom: 48 }}>
          <div style={{
            width: 72, height: 72, borderRadius: 22, background: T.forest,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 8px 24px rgba(45,80,22,0.25)',
          }}>
            <ButterflyMark size={50} color="#F5F1E8" />
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontFamily: T.fontSerif, fontSize: 32, fontWeight: 500, color: T.ink, letterSpacing: '-0.02em' }}>Unified Butterfly Recorder</div>
          </div>
        </div>

        {/* Mode toggle */}
        <div style={{ display: 'flex', background: T.bgDeep, borderRadius: 9999, padding: 4, gap: 4, marginBottom: 32 }}>
          {[['login', 'Sign in'], ['signup', 'Create account']].map(([v, l]) => (
            <button key={v} onClick={() => setMode(v)} style={{
              flex: 1, height: 40, border: 'none',
              background: mode === v ? T.card : 'transparent',
              color: mode === v ? T.ink : T.ink2,
              fontFamily: T.font, fontSize: 14, fontWeight: 600,
              borderRadius: 9999, cursor: 'pointer',
              boxShadow: mode === v ? '0 1px 2px rgba(0,0,0,0.06)' : 'none',
            }}>{l}</button>
          ))}
        </div>

        <form onSubmit={handleSubmit}>
          {mode === 'signup' && (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              {field('First name', 'firstName', 'text', 'Jane')}
              {field('Last name', 'lastName', 'text', 'Doe')}
            </div>
          )}
          {mode === 'signup' && field('Email', 'email', 'email', 'jane@example.com')}
          {field('Username', 'username')}
          {field('Password', 'password', 'password')}

          <button type="submit" style={{
            width: '100%', height: 56, marginTop: 8,
            background: T.forest, color: '#fff', border: 'none',
            borderRadius: T.r.md, fontFamily: T.font, fontSize: 17, fontWeight: 600,
            letterSpacing: '-0.01em', cursor: 'pointer',
            boxShadow: '0 1px 0 rgba(0,0,0,0.04), 0 4px 14px rgba(45,80,22,0.18)',
          }}>
            {mode === 'login' ? 'Sign in' : 'Create account'}
          </button>
        </form>
      </div>
    </div>
  );
}
